const dev = {
	apps: [
		{
			pusher: {
				key: '046c49c2dedd4a51d490'
			},
			// app_urls: ['http://192.168.1.179:3000'],
			// api_url: 'http://192.168.1.179:8000',
			app_urls: ['http://localhost:3000'],
			api_url: 'http://localhost:8000',
			// api_url: 'https://api.projectmix.eu',
			app_name: 'mixglobal',
			client_name: 'Mix Global'
		}
	]
};

const staging = {
	apps: [
		{
			pusher: {
				key: '046c49c2dedd4a51d490'
			},
			app_urls: ['http://192.168.1.14:3000'],
			api_url: 'http://192.168.1.14:8000',
			app_name: 'mixglobal',
			client_name: 'Mix Global'
		}
	]
};
const prod = {
	apps: [
		{
			pusher: {
				key: 'd31f11893093d99d05dc'
			},
			app_urls: ['https://www.mg.projectmix.ai', 'https://mg.projectmix.ai'],
			api_url: 'https://mgapi.projectmix.ai',
			app_name: 'mixglobal',
			client_name: 'Mix Global'
		},
		{
			pusher: {
				key: 'd31f11893093d99d05dc'
			},
			app_urls: ['https://www.pmmg.projectmix.ai', 'https://pmmg.projectmix.ai'],
			api_url: 'https://pmmgapi.projectmix.ai',
			app_name: 'mixglobal',
			client_name: 'Mix Global'
		}, 
		{
			pusher: {
				key: 'd31f11893093d99d05dc'
			},
			app_urls: ['https://www.mixglobal.projectmix.ai', 'https://mixglobal.projectmix.ai'],
			api_url: 'https://mixglobalapi.projectmix.ai',
			app_name: 'mixglobal',
			client_name: 'Mix Global'
		}, 
		{
			pusher: {
				key: 'd31f11893093d99d05dc'
			},
			app_urls: ['https://www.diar.projectmix.ai', 'https://diar.projectmix.ai'],
			api_url: 'https://diarapi.projectmix.ai',
			app_name: 'diar',
			client_name: 'Diar Trade'
		}, 
	]
};

const config = {
	// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
	// like '/projectmix-material-react/react/default'
	basename: '',
	defaultPath: '/dashboard',
	fontFamily: "'Roboto', sans-serif",
	borderRadius: 12,
	...(process.env.REACT_APP_STAGE === 'prod' ? prod : process.env.REACT_APP_STAGE === 'staging' ? staging : dev)
};

export default config;